import styled from 'styled-components';

import {
  Flex,
  icons,
  SVG,
} from 'web-styled';

export const Day = styled.div`
  width: 100%;
  padding-top: 32px;
  background-color: rgba(240, 240, 240, 0.5);
`;

export const LinkLabel = styled.span<{ missed?: string }>`
  color: ${props => props.theme.colors.primary};
  text-transform: capitalize;
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;

  &:hover {
    color: #757575;
  }

  & > div {
    margin-right: 9px;
  }

  ${props => props.missed === '1' && `
    color: #e7594f !important;
    &:before {
      content: '';
      position: relative;
      display: inline-block;
      width: 12px;
      height: 12px;
      margin-right: 8px;
      background: url(${icons.missedWorkout}) no-repeat;
      background-size: contain;
    }
  `};
`;

export const DynamicCounter = styled.span<{ positive: boolean }>`
  color: ${props => (props.positive
    ? props.theme.colors.completed
    : props.theme.colors.notCompleted)};

  svg {
    width: 5px;
    height: 9px;
    margin-left: 10px;
  }
`;

export const PositiveDynamic = styled(SVG.PositiveDynamic).attrs(
  props => ({
    fill: props.theme.colors.completed,
  }),
)``;

export const NegativeDynamic = styled(SVG.NegativeDynamic).attrs(
  props => ({
    fill: props.theme.colors.notCompleted,
  }),
)``;

export const EmptyList = styled(Flex).attrs({
  fillSpace: true,
  justify: 'center',
})`
  opacity: 0.6;
  white-space: pre-line;
  text-align: center;
  width: 100%;
  height: 100px;
  margin: 50px 0;
  padding-top: 50px;
  background-image: url(${icons.workoutsSingle});
  background-repeat: no-repeat;
  background-position: top center;
`;
